import { createLogger } from '~~/shared/utils/logger'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  const logger = createLogger({
    level: config.public.logLevel,
    tag: 'app error-handler',
    fancy: import.meta.env.MODE !== 'production'
  })

  nuxtApp.hook('vue:error', (error, instance, info) => {
    logger.error('Vue error:', error, 'Instance:', instance, 'Info:', info)
  })

  nuxtApp.hook('app:error', (error) => {
    logger.error('App error:', error)
  })
})
